import { render, staticRenderFns } from "./ResolutionStep.vue?vue&type=template&id=2bc2c084&scoped=true"
import script from "./ResolutionStep.vue?vue&type=script&lang=js"
export * from "./ResolutionStep.vue?vue&type=script&lang=js"
import style0 from "./ResolutionStep.vue?vue&type=style&index=0&id=2bc2c084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc2c084",
  null
  
)

export default component.exports